var render = function () {
  var _vm$response$product$, _vm$response$similar, _vm$response$viewed;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "product-page__main"
  }, [_c('div', {
    staticClass: "product-page__slider"
  }, [_c('ProductPhotoSlider', {
    attrs: {
      "photo": _vm.response.product.thumb,
      "alt": _vm.response.product.name,
      "zoom-type": "adaptive"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "product-page__info-section product-page__info-statistics_mobile"
  }, [_c('ProductStatistics', {
    attrs: {
      "link": _vm.response.product.path,
      "is-bought": _vm.response.product.isBought,
      "data": {
        review: _vm.response.product.rate,
        questionCount: _vm.response.product.questionCount
      }
    }
  }), _vm._v(" "), _vm.isShowSuggestorButton ? _c('button', {
    staticClass: "suggestor-button product-page__suggestor-button-mobile",
    attrs: {
      "data-product-id": _vm.response.product.id
    }
  }, [_vm._v("\n        ИИ в помощь: сравнить товары 🔍\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "product-page__actions"
  }, [_c('UserTools', {
    staticClass: "product-page__tools",
    attrs: {
      "product": _vm.response.product,
      "data-e2e": "product-user-tools"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "product-page__info"
  }, [_vm.response.product.seller.length ? _c('div', {
    staticClass: "product-page__info-section"
  }, [_c('SellerList', {
    attrs: {
      "value": _vm.currentSeller,
      "list": _vm.response.product.seller
    },
    on: {
      "change": function ($event) {
        _vm.currentSeller = $event;
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.response.product.code || _vm.response.product.brand || _vm.response.product.guarantee ? _c('div', {
    staticClass: "product-page__info-section"
  }, [_vm.response.product.code ? _c('div', {
    staticClass: "product-page__code"
  }, [_vm._v("\n          Код товара: "), _c('span', {
    staticClass: "b"
  }, [_vm._v(_vm._s(_vm.response.product.code))])]) : _vm._e(), _vm._v(" "), _vm.response.product.brand ? _c('div', {
    staticClass: "product-page__brand"
  }, [_vm._v("\n          Производитель:\n          "), _c('nuxt-link', {
    staticClass: "link",
    attrs: {
      "to": ("/brands/" + (_vm.response.product.brand.code) + "/")
    }
  }, [_vm._v("\n            " + _vm._s(_vm.response.product.brand.name) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), _vm.response.product.guarantee ? _c('div', {
    staticClass: "product-page__guarantee"
  }, [_vm._v("\n          Гарантия: " + _vm._s(_vm.response.product.guarantee) + "\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "product-page__info-section product-page__info-statistics"
  }, [_c('ProductStatistics', {
    attrs: {
      "link": _vm.response.product.path,
      "is-bought": _vm.response.product.isBought,
      "data": {
        review: _vm.response.product.rate,
        questionCount: _vm.response.product.questionCount
      }
    }
  })], 1), _vm._v(" "), _vm.saleActiveTime() ? [_vm.promoProductText ? _c('div', {
    staticClass: "product-page__info-section"
  }, [_c('PromoBanner', {
    attrs: {
      "sale": _vm.promoProductText
    }
  })], 1) : _c('div', {
    staticClass: "product-page__info-section"
  }, [_c('SaleBanner')], 1)] : _vm._e(), _vm._v(" "), _vm.isShowSuggestorButton ? _c('button', {
    staticClass: "suggestor-button product-page__suggestor-button-desktop mb-15",
    attrs: {
      "data-product-id": _vm.response.product.id
    }
  }, [_vm._v("\n        ИИ в помощь: сравнить товары 🔍\n      ")]) : _vm._e(), _vm._v(" "), _vm.response.product.freeLift ? _c('div', {
    staticClass: "product-page__info-section"
  }, [_c('InfoBlockLargeEquipment', {
    attrs: {
      "product-card": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.response.product.sale.length ? _c('div', {
    staticClass: "product-page__info-section product-page__info-section_sales"
  }, [_c('SaleMarkerList', {
    attrs: {
      "list": _vm.response.product.sale
    }
  })], 1) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "product-page__section product-page__section_price"
  }, [_c('div', {
    staticClass: "product-page__price-block"
  }, [_c('ProductPriceBlock', {
    attrs: {
      "product": _vm.response.product,
      "offer": _vm.response.offer,
      "is-pre-order": _vm.isPreOrder
    },
    scopedSlots: _vm._u([{
      key: "button",
      fn: function () {
        return [_c('ActionCart', {
          attrs: {
            "id": _vm.response.product.id,
            "product": Object.assign({}, _vm.response.product, {
              id: _vm.response.product.code
            }),
            "actions": {
              send: _vm.$api.cart.add
            },
            "modal": {
              image: _vm.response.product.image,
              link: _vm.response.product.path,
              name: _vm.response.product.name,
              price: _vm.response.product.price,
              category: _vm.response.product.category,
              offer: _vm.response.product.offer,
              id: _vm.response.product.id
            },
            "source": "Карточка товара",
            "receive-quantity-from-api": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref) {
              var add = _ref.add,
                  error = _ref.error,
                  loading = _ref.loading;
              return [_c('AddToCart', {
                staticClass: "mb-9",
                attrs: {
                  "count": _vm.cartCount,
                  "error": error,
                  "loading": loading,
                  "type": _vm.isPreOrder ? 'preorder' : 'default'
                },
                on: {
                  "send": function ($event) {
                    return add({
                      id: _vm.response.product.id,
                      quantity: _vm.cartCount + 1
                    });
                  }
                }
              })];
            }
          }])
        }), _vm._v(" "), !_vm.isPreOrder && _vm.price && _vm.price >= 3000 && _vm.price <= 200000 ? _c('LazyLoan', {
          staticClass: "mb-8 mt-15",
          attrs: {
            "product": _vm.response.product
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref2) {
              var loading = _ref2.loading,
                  enableCalculation = _ref2.enableCalculation;
              return [_c('InfoBlockInstallment', {
                attrs: {
                  "loading": loading,
                  "product": _vm.response.product
                },
                on: {
                  "enable": function ($event) {
                    return enableCalculation();
                  }
                }
              })];
            }
          }], null, false, 3125406188)
        }) : _vm._e(), _vm._v(" "), _vm.response.product.isCreditAvailable && _vm.price && _vm.price >= 3000 ? _c('Button', {
          staticClass: "mb-8",
          attrs: {
            "theme": "blue",
            "icon": "calendar",
            "fluid": ""
          },
          on: {
            "click": _vm.onClickBuyCredit
          }
        }, [_vm._v("\n            Купить в кредит\n          ")]) : _vm._e(), _vm._v(" "), _c('UIActionEntity', {
          attrs: {
            "get": _vm.$api.product.buyOneClick
          },
          on: {
            "success": _vm.onSuccessQuickOrder
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref3) {
              var get = _ref3.get,
                  status = _ref3.status,
                  responseQuickOrder = _ref3.response;
              return [_c('QuickOrderToggle', {
                attrs: {
                  "product-id": _vm.response.product.id,
                  "status": status,
                  "response": responseQuickOrder
                },
                on: {
                  "send": function ($event) {
                    get($event);

                    _vm.emitter.emit('quick-order-submitted', {
                      phone: $event.number
                    });
                  }
                }
              })];
            }
          }])
        })];
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), _vm.response.product.availability.length && _vm.response.product.delivery.length ? [_c('DeliveryType', {
    staticClass: "mt-8",
    attrs: {
      "availability": _vm.response.product.availability,
      "delivery": _vm.response.product.delivery
    }
  })] : _vm._e(), _vm._v(" "), (_vm$response$product$ = _vm.response.product.price) !== null && _vm$response$product$ !== void 0 && _vm$response$product$.common ? _c('div', {
    staticClass: "product-page__cheaper-wrap"
  }, [_c('Toggle', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref4) {
        var onClick = _ref4.onClick,
            isActive = _ref4.isActive;
        return [_c('div', {
          staticClass: "product-page__cheaper",
          class: [{
            'product-page__cheaper_active': isActive
          }],
          attrs: {
            "data-e2e": "cheaper-button"
          }
        }, [_c('div', {
          staticClass: "product-page__cheaper-text",
          on: {
            "click": onClick
          }
        }, [_vm._v("\n              Нашли дешевле?\n            ")]), _vm._v(" "), isActive ? _c('div', {
          staticClass: "product-page__cheaper-content"
        }, [_c('nuxt-link', {
          staticClass: "link link_blue fz-17",
          attrs: {
            "to": "/sales/garantiya-luchshey-tseny/"
          }
        }, [_vm._v("\n                Гарантия лучшей цены\n              ")]), _vm._v(" "), _c('p', {
          staticClass: "p mb-8 mt-9"
        }, [_vm._v("\n                Оставьте ссылку на товар, который вы нашли, и телефон, мы вам перезвоним.\n              ")]), _vm._v(" "), _c('UIActionEntity', {
          attrs: {
            "get": _vm.$api.product.foundCheaper
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref5) {
              var get = _ref5.get,
                  status = _ref5.status,
                  responseFoundCheaper = _ref5.responseFoundCheaper;
              return [_c('FoundCheaper', {
                attrs: {
                  "product-id": _vm.response.product.id,
                  "status": status,
                  "response": responseFoundCheaper
                },
                on: {
                  "send": function ($event) {
                    get($event), _vm.emitter.emit('submit-form-data', {
                      phone: $event.number
                    });
                  }
                }
              })];
            }
          }], null, true)
        })], 1) : _vm._e()])];
      }
    }], null, false, 486146357)
  })], 1) : _vm._e()], 2), _vm._v(" "), _vm.response.product.accessory.length ? _c('div', {
    staticClass: "product-page__section"
  }, [_c('nuxt-link', {
    staticClass: "product-page__section-title",
    attrs: {
      "to": ((_vm.response.product.path) + "accessory/")
    }
  }, [_c('span', [_vm._v("Аксессуары")]), _vm._v(" "), _c('div', {
    staticClass: "product-page__section-title-icon"
  })]), _vm._v(" "), _c('ViewportToogle', {
    scopedSlots: _vm._u([{
      key: "desktop",
      fn: function () {
        return [_c('RowSliderNew', {
          staticClass: "row-slider_product row-slider_single",
          attrs: {
            "list": _vm.response.product.accessory,
            "offset-between-elements": 10
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref6) {
              var el = _ref6.el,
                  index = _ref6.index;
              return [_c('TSProductCard', {
                key: el.id,
                staticClass: "row-slider__product",
                attrs: {
                  "product": el,
                  "photo-lazy-load": false,
                  "source": "Аксессуары"
                },
                on: {
                  "add-product": function ($event) {
                    return _vm.emitter.emit('add-to-cart-accessory', {
                      product: el,
                      type: 'card'
                    });
                  },
                  "product-select": function ($event) {
                    return _vm.emitter.emit('product-select', {
                      product: el,
                      listName: 'Аксессуары',
                      index: index
                    });
                  }
                }
              })];
            }
          }], null, false, 1323754960)
        })];
      },
      proxy: true
    }, {
      key: "mobile",
      fn: function () {
        return [_c('TSProductPromo', {
          attrs: {
            "items": _vm.response.product.accessory,
            "count": 6
          },
          on: {
            "link-click": function ($event) {
              return _vm.emitter.emit('product-select', {
                product: $event.product,
                listName: 'Аксессуары',
                index: $event.index
              });
            }
          }
        })];
      },
      proxy: true
    }], null, false, 2006855209)
  }), _vm._v(" "), _c('nuxt-link', {
    staticClass: "product-page__section-link link link_wu",
    attrs: {
      "to": ((_vm.response.product.path) + "accessory/")
    }
  }, [_c('span', [_vm._v("Посмотреть все аксессуары")]), _vm._v(" "), _c('div', {
    staticClass: "product-page__section-link-icon"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm$response$similar = _vm.response.similar) !== null && _vm$response$similar !== void 0 && _vm$response$similar.list.length ? _c('div', {
    staticClass: "product-page__section product-page__section_simillar"
  }, [_c('div', {
    staticClass: "product-page__section-title"
  }, [_vm._v("\n      " + _vm._s(_vm.response.similar.title) + "\n    ")]), _vm._v(" "), _c('ViewportToogle', {
    scopedSlots: _vm._u([{
      key: "desktop",
      fn: function () {
        return [_c('RowSliderNew', {
          staticClass: "row-slider_product row-slider_single",
          attrs: {
            "list": _vm.response.similar.list,
            "offset-between-elements": 10
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref7) {
              var el = _ref7.el,
                  index = _ref7.index;
              return [_c('TSProductCard', {
                key: el.id,
                staticClass: "row-slider__product",
                attrs: {
                  "product": el,
                  "photo-lazy-load": false,
                  "compact": true
                },
                on: {
                  "product-select": function ($event) {
                    return _vm.emitter.emit('product-select', {
                      product: el,
                      listName: 'Похожие товары',
                      index: index
                    });
                  }
                }
              })];
            }
          }], null, false, 1858404585)
        })];
      },
      proxy: true
    }, {
      key: "mobile",
      fn: function () {
        return [_c('TSProductPromo', {
          attrs: {
            "items": _vm.response.similar.list,
            "count": 6
          },
          on: {
            "link-click": function ($event) {
              return _vm.emitter.emit('product-select', {
                product: $event.product,
                listName: 'Похожие товары',
                index: $event.index
              });
            }
          }
        })];
      },
      proxy: true
    }], null, false, 339788772)
  })], 1) : _vm._e(), _vm._v(" "), _vm.response.product.richContent ? _c('div', {
    staticClass: "product-page__section"
  }, [_c('RichContent', {
    attrs: {
      "brand": _vm.response.product.richContent.brand,
      "product-id": _vm.response.product.richContent.id
    }
  })], 1) : _vm.response.product.description ? _c('div', {
    staticClass: "product-page__section"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "product-page__section-description inner-tag-transform",
    domProps: {
      "innerHTML": _vm._s(_vm.response.product.description)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "product-page__section"
  }, [_c('nuxt-link', {
    staticClass: "product-page__section-title",
    attrs: {
      "to": ((_vm.response.product.path) + "property/")
    }
  }, [_c('span', [_vm._v("Характеристики")]), _vm._v(" "), _c('div', {
    staticClass: "product-page__section-title-icon"
  })]), _vm._v(" "), _vm.response.product.propertyGroup.length ? [_vm.response.product.basicProperties.length ? _c('Specifications', {
    staticClass: "product-props-grid__el mb-15",
    attrs: {
      "properties": _vm.response.product.basicProperties
    }
  }) : _vm._e(), _vm._v(" "), _c('nuxt-link', {
    staticClass: "product-page__section-link link link_wu",
    attrs: {
      "to": ((_vm.response.product.path) + "property/")
    }
  }, [_c('span', [_vm._v("Посмотреть все характеристики")]), _vm._v(" "), _c('div', {
    staticClass: "product-page__section-link-icon"
  })])] : _c('StatusBlock', {
    attrs: {
      "size": "s",
      "type": "empty",
      "title": "Для товара нет характеристик"
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "product-page__section"
  }, [_vm.response.product.review.length ? [_c('nuxt-link', {
    staticClass: "product-page__section-title",
    attrs: {
      "to": ((_vm.response.product.path) + "review/")
    }
  }, [_c('span', [_vm._v("Отзывы " + _vm._s(+_vm.response.product.rate.reviewCount ? _vm.response.product.rate.reviewCount : ''))]), _vm._v(" "), _c('div', {
    staticClass: "product-page__section-title-icon"
  })]), _vm._v(" "), _c('ReviewRating', {
    staticClass: "product-page__review-rating",
    attrs: {
      "data": _vm.response.product.rate,
      "link": "review/create/"
    }
  }), _vm._v(" "), _c('ViewportToogle', {
    scopedSlots: _vm._u([{
      key: "desktop",
      fn: function () {
        return [_vm._l(_vm.response.product.review.slice(0, 2), function (item) {
          return [_c('UIActionList', {
            key: item.id,
            attrs: {
              "actions": {
                like: _vm.$api.review.like,
                dislike: _vm.$api.review.dislike
              }
            },
            on: {
              "error": _vm.onError
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function (_ref8) {
                var like = _ref8.like,
                    dislike = _ref8.dislike;
                return [_c('Review', {
                  key: item.id,
                  staticClass: "mb-20",
                  attrs: {
                    "data": item,
                    "product-id": _vm.response.product.id,
                    "data-e2e": "product-review-block",
                    "data-review-id": item.id
                  },
                  on: {
                    "positive": function ($event) {
                      _vm.recalculateLikes({
                        send: function () {
                          return like.request($event);
                        },
                        data: item,
                        param: 'like',
                        param2: 'dislike'
                      });
                    },
                    "negative": function ($event) {
                      _vm.recalculateLikes({
                        send: function () {
                          return dislike.request($event);
                        },
                        data: item,
                        param: 'dislike',
                        param2: 'like'
                      });
                    },
                    "report": function ($event) {
                      return _vm.enableReport(_vm.response.product.id);
                    }
                  },
                  scopedSlots: _vm._u([{
                    key: "response",
                    fn: function (_ref9) {
                      var data = _ref9.data,
                          toggleShow = _ref9.toggleShow;
                      return [_c('UIActionEntity', {
                        attrs: {
                          "get": _vm.$api.review.addComment
                        },
                        on: {
                          "error": _vm.onError,
                          "success": function ($event) {
                            return _vm.onSuccessAddedComment({
                              toggleShow: toggleShow
                            });
                          }
                        },
                        scopedSlots: _vm._u([{
                          key: "default",
                          fn: function (_ref10) {
                            var get = _ref10.get;
                            return [_c('ReviewComment', {
                              attrs: {
                                "id": data.id,
                                "name": data.name,
                                "placeholder": ("Ответ пользователю " + (data.name)),
                                "product-id": _vm.response.product.id
                              },
                              on: {
                                "click": get
                              }
                            })];
                          }
                        }], null, true)
                      })];
                    }
                  }, {
                    key: "commentary",
                    fn: function (_ref11) {
                      var comments = _ref11.comments,
                          data = _ref11.data;
                      return [_vm._l(comments, function (comment) {
                        return [_c('div', {
                          key: comment.id
                        }, [_c('UIActionList', {
                          attrs: {
                            "actions": {
                              likeComment: _vm.$api.review.likeComment,
                              dislikeComment: _vm.$api.review.dislikeComment
                            }
                          },
                          on: {
                            "error": _vm.onError
                          },
                          scopedSlots: _vm._u([{
                            key: "default",
                            fn: function (_ref12) {
                              var likeComment = _ref12.likeComment,
                                  dislikeComment = _ref12.dislikeComment;
                              return [_c('Comment', {
                                attrs: {
                                  "review-id": data.id,
                                  "data": comment
                                },
                                on: {
                                  "positive": function ($event) {
                                    _vm.recalculateLikes({
                                      send: function () {
                                        return likeComment.request($event);
                                      },
                                      data: comment,
                                      param: 'like',
                                      param2: 'dislike'
                                    });
                                  },
                                  "negative": function ($event) {
                                    _vm.recalculateLikes({
                                      send: function () {
                                        return dislikeComment.request($event);
                                      },
                                      data: comment,
                                      param: 'dislike',
                                      param2: 'like'
                                    });
                                  },
                                  "report": function ($event) {
                                    return _vm.enableReport(_vm.response.product.id);
                                  }
                                },
                                scopedSlots: _vm._u([{
                                  key: "default",
                                  fn: function (_ref13) {
                                    var toggleShow = _ref13.toggleShow;
                                    return [_c('UIActionEntity', {
                                      attrs: {
                                        "get": _vm.$api.review.addComment
                                      },
                                      on: {
                                        "error": _vm.onError,
                                        "success": function ($event) {
                                          return _vm.onSuccessAddedComment({
                                            toggleShow: toggleShow
                                          });
                                        }
                                      },
                                      scopedSlots: _vm._u([{
                                        key: "default",
                                        fn: function (_ref14) {
                                          var get = _ref14.get;
                                          return [_c('ReviewComment', {
                                            attrs: {
                                              "id": data.id,
                                              "name": comment.name,
                                              "placeholder": ("Ответ пользователю " + (comment.name)),
                                              "product-id": _vm.response.product.id
                                            },
                                            on: {
                                              "click": get
                                            }
                                          })];
                                        }
                                      }], null, true)
                                    })];
                                  }
                                }], null, true)
                              })];
                            }
                          }], null, true)
                        })], 1)];
                      })];
                    }
                  }], null, true)
                })];
              }
            }], null, true)
          })];
        })];
      },
      proxy: true
    }, {
      key: "mobile",
      fn: function () {
        return [_c('UIActionList', {
          key: _vm.response.product.review[0].id,
          attrs: {
            "actions": {
              like: _vm.$api.review.like,
              dislike: _vm.$api.review.dislike
            }
          },
          on: {
            "error": _vm.onError
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref15) {
              var like = _ref15.like,
                  dislike = _ref15.dislike;
              return [_c('ReviewMobile', {
                key: _vm.response.product.review[0].id,
                staticClass: "review-page__review",
                attrs: {
                  "review": _vm.response.product.review[0],
                  "product-id": _vm.response.product.id,
                  "data-e2e": "product-review-block",
                  "data-review-id": _vm.response.product.review[0].id,
                  "show-field-button": false
                },
                on: {
                  "positive": function ($event) {
                    _vm.recalculateLikes({
                      send: function () {
                        return like.request({
                          id: _vm.response.product.review[0].id
                        });
                      },
                      data: _vm.response.product.review[0],
                      param: 'like',
                      param2: 'dislike'
                    });
                  },
                  "negative": function ($event) {
                    _vm.recalculateLikes({
                      send: function () {
                        return dislike.request({
                          id: _vm.response.product.review[0].id
                        });
                      },
                      data: _vm.response.product.review[0],
                      param: 'dislike',
                      param2: 'like'
                    });
                  },
                  "report": function ($event) {
                    return _vm.enableReport(_vm.response.product.id);
                  },
                  "click-answer": function ($event) {
                    return _vm.$router.push(("review/" + (_vm.response.product.review[0].id) + "/?activeField=true"));
                  },
                  "click": function ($event) {
                    return _vm.$router.push(("review/" + (_vm.response.product.review[0].id) + "/"));
                  }
                }
              })];
            }
          }], null, false, 1768015724)
        })];
      },
      proxy: true
    }], null, false, 2247748289)
  }), _vm._v(" "), _c('nuxt-link', {
    staticClass: "product-page__section-link link link_wu",
    attrs: {
      "to": ((_vm.response.product.path) + "review/")
    }
  }, [_c('span', [_vm._v("Посмотреть все отзывы")]), _vm._v(" "), _c('div', {
    staticClass: "product-page__section-link-icon"
  })])] : _c('ProductEmptyBlock', {
    attrs: {
      "title": "Отзывов ещё нет — ваш может стать первым",
      "description": "Будет здорово, если вы первыми напишите свои впечатления о товаре. Это поможет другим покупателям.",
      "type": "review"
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "product-page__section"
  }, [_vm.response.product.question.length ? _c('div', [_c('nuxt-link', {
    staticClass: "product-page__section-title",
    attrs: {
      "to": ((_vm.response.product.path) + "question/")
    }
  }, [_c('span', [_vm._v("Вопросы и ответы")]), _vm._v(" "), _c('div', {
    staticClass: "product-page__section-title-icon"
  })]), _vm._v(" "), _c('ViewportToogle', {
    scopedSlots: _vm._u([{
      key: "desktop",
      fn: function () {
        return _vm._l(_vm.response.product.question.slice(0, 2), function (item) {
          return _c('div', {
            key: item.id,
            staticClass: "product-page__question-item"
          }, [_c('Question', {
            attrs: {
              "question": item,
              "product-id": _vm.response.product.id,
              "data-e2e": "product-question-block"
            },
            on: {
              "report": function ($event) {
                return _vm.enableReport(_vm.response.product.id);
              },
              "add-answer": _vm.addAnswerHandler
            }
          })], 1);
        });
      },
      proxy: true
    }, {
      key: "mobile",
      fn: function () {
        return [_c('QuestionMobile', {
          key: _vm.response.product.question[0].id,
          attrs: {
            "question": _vm.response.product.question[0],
            "product-id": _vm.response.product.id,
            "data-e2e": "product-question-block"
          },
          on: {
            "click": function ($event) {
              return _vm.$router.push(("question/" + (_vm.response.product.question[0].id) + "/"));
            },
            "click-answer": function ($event) {
              return _vm.$router.push(("question/" + (_vm.response.product.question[0].id) + "?activeField=true"));
            },
            "report": function ($event) {
              return _vm.enableReport(_vm.response.product.id);
            }
          }
        })];
      },
      proxy: true
    }], null, false, 1923800764)
  }), _vm._v(" "), _c('nuxt-link', {
    staticClass: "product-page__section-link link link_wu",
    attrs: {
      "to": ((_vm.response.product.path) + "question/")
    }
  }, [_c('span', [_vm._v("Читать все вопросы и ответы")]), _vm._v(" "), _c('div', {
    staticClass: "product-page__section-link-icon"
  })])], 1) : _c('ProductEmptyBlock', {
    attrs: {
      "title": "Есть вопросы о товаре?",
      "description": "Пока никто не задавал вопросы — станьте первым.",
      "type": "question"
    }
  })], 1), _vm._v(" "), (_vm$response$viewed = _vm.response.viewed) !== null && _vm$response$viewed !== void 0 && _vm$response$viewed.list.length ? _c('div', {
    staticClass: "product-page__section"
  }, [_c('div', {
    staticClass: "product-page__section-title"
  }, [_vm._v("\n      Просмотренные товары\n    ")]), _vm._v(" "), _c('ViewportToogle', {
    staticClass: "product-page__row-slider product-page__row-slider_viewed",
    scopedSlots: _vm._u([{
      key: "desktop",
      fn: function () {
        return [_c('RowSliderNew', {
          staticClass: "row-slider_product row-slider_single",
          attrs: {
            "list": _vm.response.viewed.list,
            "offset-between-elements": 10
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref16) {
              var el = _ref16.el,
                  index = _ref16.index;
              return [_c('TSProductCard', {
                key: el.id,
                staticClass: "row-slider__product",
                attrs: {
                  "product": el,
                  "compact": true
                },
                on: {
                  "product-select": function ($event) {
                    return _vm.emitter.emit('product-select', {
                      product: el,
                      listName: 'Просмотренные товары',
                      index: index
                    });
                  }
                }
              })];
            }
          }], null, false, 964735692)
        })];
      },
      proxy: true
    }, {
      key: "mobile",
      fn: function () {
        return [_c('TSProductPromo', {
          attrs: {
            "items": _vm.response.viewed.list,
            "count": 6
          },
          on: {
            "link-click": function ($event) {
              return _vm.emitter.emit('product-select', Object.assign({}, $event, {
                listName: 'Просмотренные товары',
                index: $event.index
              }));
            }
          }
        })];
      },
      proxy: true
    }], null, false, 1775798922)
  })], 1) : _vm._e()]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "product-page__section-title"
  }, [_c('span', [_vm._v("О товаре")])]);
}]

export { render, staticRenderFns }